export default __webpack_public_path__ + "static/media/swicth.ed4811d7.svg";